<div class="registaration">
    <!-- Confetti Container -->
    <div #confetti class="confetti-container"></div>
    
    <div class="r-header">
        <img src="assets/images/logo-dark.svg" alt="">
    </div>
    <div class="sidebar">
        <img src="assets/images/logo.svg" class="logo" alt="">
        <h2>
            Secure your subscription and manage everything in one place.
        </h2>
        <img src="assets/images/r-sidebar-v.svg" class="r-sidebar-v animated" alt="">
    </div>
    <div class="form-body">
        <div class="successfully-payment">
            <img src="assets/images/check222.png" class="check animated-zoom" alt="">
            <h3 class="title">
                Successfully Payment
            </h3>
            <button class="btn btn-primary-outline btn-md w-100">
                View Invoice
            </button>
            <button class="btn btn-primary btn-md w-100" (click)="goToHomepage()">
                {{ isLoggedIn ? 'Go to Dashboard' : 'Login' }}
            </button>
        </div>
    </div>
</div>